module.exports = __webpack_public_path__ + "static/media/newMarketingTile.d265b657.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg/newMarketingTile.png
// module id = 1507
// module chunks = 0